import { IEnumOption } from 'modules/shared/interfaces/enumOptions';

export enum Region {
	RIYADH,
	MAKKAH,
	EASTERN_PROVINCE,
	ASIR,
	MEDINA,
	TABUK,
	QASSIM,
	AL_JOWF,
	HAIL,
	JAZAN,
	NORTHERN_BORDERS,
	NAJRAN,
	AL_BAHA,
	MODULES_REGION,
}

export enum LessonType {
	VOCAB,
	SENTENCE,
	LEXICAL,
	VERB,
	GRAMMAR,
	SORTING,
	BUSY_PICTURE,
	NUMBER_COMBINATION,
	SIGHT_WORDS,
	TIME,
	SCENE_MATCHING,
}

export enum VerbLessonPronoun {
	I, // أنا
	YOU_MALE, // أنت
	YOU_FEMALE, // أنتِ
	YOU_PLURAL, // أنتم
	HE, // هو
	SHE, // هي
	WE, // احنا
	THEY, // هم
}

export enum BusyPictureQuestionType {
	YES_NO,
	WHERE,
}

export enum TimeLessonLevel {
	ONLY_HOURS,
	HOURS_AND_MINUTES,
	NATIVE_SPEAKER,
}

export const regionEnumOptions: IEnumOption[] = [
	{
		value: Region.RIYADH,
		label: 'Riyadh',
	},
	{
		value: Region.MAKKAH,
		label: 'Makkah',
	},
	{
		value: Region.EASTERN_PROVINCE,
		label: 'Eastern Province',
	},
	{
		value: Region.ASIR,
		label: 'Asir',
	},
	{
		value: Region.MEDINA,
		label: 'Medina',
	},
	{
		value: Region.TABUK,
		label: 'Tabuk',
	},
	{
		value: Region.QASSIM,
		label: 'Qassim',
	},
	{
		value: Region.AL_JOWF,
		label: 'Al Jouf',
	},
	{
		value: Region.HAIL,
		label: 'Hail',
	},
	{
		value: Region.JAZAN,
		label: 'Jazan',
	},
	{
		value: Region.NORTHERN_BORDERS,
		label: 'Northern Borders',
	},
	{
		value: Region.NAJRAN,
		label: 'Najran',
	},
	{
		value: Region.AL_BAHA,
		label: 'Al Baha',
	},
];

export const regionEnumOptionsWithModulesRegion = [
	...regionEnumOptions,
	{
		value: Region.MODULES_REGION,
		label: 'Modules',
	},
];

export const lessonTypeEnumOptions: IEnumOption[] = [
	{ value: LessonType.VOCAB, label: 'Vocabulary' },
	{ value: LessonType.VERB, label: 'Verb' },
	{ value: LessonType.SENTENCE, label: 'Sentence' },
	{ value: LessonType.LEXICAL, label: 'Lexicary' },
	{ value: LessonType.GRAMMAR, label: 'Grammar' },
	{ value: LessonType.SORTING, label: 'Sorting' },
	{ value: LessonType.BUSY_PICTURE, label: 'Busy picture' },
	{ value: LessonType.NUMBER_COMBINATION, label: 'Number combination' },
	{ value: LessonType.SIGHT_WORDS, label: 'Sight words' },
	{ value: LessonType.TIME, label: 'Time' },
	{ value: LessonType.SCENE_MATCHING, label: 'Scene matching' },
];

export const verbLessonPronounOptions: IEnumOption[] = [
	{ value: VerbLessonPronoun.I, label: '(I) - أنا' },
	{ value: VerbLessonPronoun.YOU_MALE, label: '(You male) - أنت' },
	{ value: VerbLessonPronoun.YOU_FEMALE, label: '(You female) - أنتِ' },
	{ value: VerbLessonPronoun.YOU_PLURAL, label: '(You plural) - أنتم' },
	{ value: VerbLessonPronoun.HE, label: '(He) - هو' },
	{ value: VerbLessonPronoun.SHE, label: '(She) - هي' },
	{ value: VerbLessonPronoun.WE, label: '(We) - إحنا' },
	{ value: VerbLessonPronoun.THEY, label: '(They) - هم' },
];

export const busyPictureQuestionOptions: IEnumOption[] = [
	{ value: BusyPictureQuestionType.YES_NO, label: 'Yes/No' },
	{ value: BusyPictureQuestionType.WHERE, label: 'Where' },
];

export const timeLessonLevelOptions: IEnumOption[] = [
	{ value: TimeLessonLevel.ONLY_HOURS, label: 'Only hours' },
	{ value: TimeLessonLevel.HOURS_AND_MINUTES, label: 'Hours and minutes' },
	{
		value: TimeLessonLevel.NATIVE_SPEAKER,
		label: 'Native speaker',
	},
];
